<template>
    <v-popover popoverInnerClass="w-100 h-100">
        <slot name="title"></slot>
        <div class="app-color-picker-trigger"
             v-tooltip="tooltip"
             :style="`background-color: ${value}`">
        </div>
        <slot name="caption"></slot>
        <template slot="popover">
            <ColorPicker :value="value" @input="({hex}) => $emit('input', hex)"/>
        </template>
    </v-popover>
</template>

<script>
import ColorPicker from 'vue-color/src/components/Chrome.vue'

export default {
    name: 'AppColorPicker',
    components: {
        ColorPicker
    },
    props: {
        value: { // hex
            type: String,
            default: '#8b3694'
        },
        tooltip: {
            type: String,
            default: ''
        }
    },
    model: {
        prop: 'value',
        event: 'input'
    }
}
</script>

<style scoped lang="scss">
.app-color-picker-trigger {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid $color-grey-light;

    &:hover {
        cursor: pointer;
    }
}
</style>
